import { ButtonProps, default as MobiusButton } from "@insite/mobius/Button"; // eslint-disable-line
import TextField from "@insite/mobius/TextField";
import {
    ButtonSizeVariant,
    ButtonVariant,
    MobiusButtonSizeVariant,
    MobiusButtonVariant,
} from "@toolkit/Framework/Types/Button";
import Upload from "@toolkit/Library/Components/Icons/Upload";
import {
    StyleguideCell,
    StyleguideCellInvert,
    StyleguideHead,
    StyleguideItems,
    StyleguideRow,
    StyleguideSection,
    StyleguideTable,
    StyleguideTableBody,
} from "@toolkit/Library/Components/Styleguide/ui";
import { buttonGetColorProps } from "@toolkit/Themes/common/props";
import upperFirst from "lodash/upperFirst";
import React, { FC } from "react";

interface ButtonVariantProps {
    variant: ButtonVariant;
}

interface ButtonVariantRowProps extends ButtonVariantProps {
    sizeVariant: ButtonSizeVariant;
}

interface ButtonIconProps extends ButtonProps {
    iconPosition: "right" | "left";
}

const Button: FC<ButtonProps> = props => <MobiusButton {...props}>Button</MobiusButton>;
const ButtonIcon: FC<ButtonIconProps> = ({ iconPosition, ...props }) => (
    <Button
        icon={{
            src: Upload,
            position: iconPosition,
        }}
        {...props}
    />
);
const ButtonInvert: FC<ButtonProps> = props => <Button {...buttonGetColorProps("invert", "invert.dark")} {...props} />;

const ButtonVariantRow: FC<ButtonVariantRowProps> = props => {
    const variant = props.variant as MobiusButtonVariant;
    const sizeVariant = props.sizeVariant as MobiusButtonSizeVariant;

    return (
        <StyleguideRow>
            <StyleguideHead>{upperFirst(sizeVariant)}</StyleguideHead>
            <StyleguideCell>
                <Button variant={variant} sizeVariant={sizeVariant} />
            </StyleguideCell>
            <StyleguideCell>
                <Button variant={variant} sizeVariant={sizeVariant} disabled />
            </StyleguideCell>
            <StyleguideCell>
                <ButtonIcon variant={variant} sizeVariant={sizeVariant} iconPosition="left" />
            </StyleguideCell>
            <StyleguideCell>
                <ButtonIcon variant={variant} sizeVariant={sizeVariant} iconPosition="right" />
            </StyleguideCell>
            <StyleguideCellInvert>
                <ButtonInvert variant={variant} sizeVariant={sizeVariant} />
            </StyleguideCellInvert>
        </StyleguideRow>
    );
};

const ButtonVariant: FC<ButtonVariantProps> = ({ variant }) => (
    <StyleguideSection variant="h3" title={upperFirst(variant)}>
        <StyleguideTable>
            <StyleguideTableBody>
                <StyleguideRow>
                    <StyleguideHead></StyleguideHead>
                    <StyleguideHead>Normal</StyleguideHead>
                    <StyleguideHead>Disabled</StyleguideHead>
                    <StyleguideHead>Left Icon</StyleguideHead>
                    <StyleguideHead>Right Icon</StyleguideHead>
                    <StyleguideHead>Inverted</StyleguideHead>
                </StyleguideRow>
                <ButtonVariantRow variant={variant} sizeVariant="small" />
                <ButtonVariantRow variant={variant} sizeVariant="medium" />
                <ButtonVariantRow variant={variant} sizeVariant="large" />
                <ButtonVariantRow variant={variant} sizeVariant="xlarge" />
            </StyleguideTableBody>
        </StyleguideTable>
        {/* <StyleguideItems>
            <TextField {...buttonGetFieldIconProps("Search", variant)} placeholder="Text field" />
        </StyleguideItems> */}
    </StyleguideSection>
);

const StyleguideButtons: FC = () => {
    return (
        <StyleguideSection title="Buttons">
            <ButtonVariant variant="primary" />
            <ButtonVariant variant="secondary" />
            <ButtonVariant variant="tertiary" />
        </StyleguideSection>
    );
};

export default StyleguideButtons;
